// src/domain/buy/repository.ts

import { Observable } from 'rxjs';
import { Buy, CreateBuyData, EditBuyData } from './model';

export abstract class BuysRepository {
    abstract getAllBuys(uid: string, cid: string | null, page: number, limit: number): Observable<any>;
    abstract createBuy(uid: string, cid: string | null, data: EditBuyData): Observable<any>;
    abstract getBuyById(uid: string, cid: string | null, id: string): Observable<any>;
    abstract delete(uid: string, cid: string | null, id: string): Observable<any>;
}
